import { QueryClient, useMutation } from '@tanstack/react-query';
import { apiEditor } from 'services/api/api';
import { EditorApiEndpoints } from 'utils/endpoints/endpoints';
import { parseCamposRegistroPayload } from 'utils/requestUtils';
import { TipoCampo } from 'utils/types/campo';

const invalidateQueries = (queryClient: QueryClient, registroCodigo: string) => 
{
  queryClient.invalidateQueries({queryKey: ['camposPorRegistro', registroCodigo]})
  queryClient.invalidateQueries({queryKey: ['selectOptions', TipoCampo.selectCampo]})
}
  

export const deleteRegistro = async (
  processamentoSpedId: string,
  registroId: number,
  registroCodigo: string,
) => {
  const response = await apiEditor.delete(
    EditorApiEndpoints.DeleteRegistro + registroCodigo,
    {
      data: { id: registroId },
      headers: {
        'Content-Type': 'application/json',
        'Processamento-Sped-ID': processamentoSpedId,
      },
    },
  );
  return response.data;
};

export const useDeleteRegistro = (
  processamentoSpedId: string,
  registroCodigo: string,
  queryClient: QueryClient,
) => {
  return useMutation({
    mutationFn: (registroId: number) =>
      deleteRegistro(processamentoSpedId, registroId, registroCodigo),
    onSuccess: () => invalidateQueries(queryClient, registroCodigo),
  });
};

export const saveRegistro = async (
  processamentoSpedId: string,
  registroCodigo: string,
  payload: any,
  isEdit: boolean,
) => {
  const endpoint = isEdit
    ? EditorApiEndpoints.EditarRegistro + registroCodigo
    : EditorApiEndpoints.AdicionarRegistro + registroCodigo;

  const method = isEdit ? 'put' : 'post';

  payload = parseCamposRegistroPayload(payload);

  const response = await apiEditor[method](endpoint, payload, {
    headers: {
      'Content-Type': 'application/json',
      'Processamento-Sped-ID': processamentoSpedId,
    },
  });

  return response.data;
};

export const useSaveRegistro = (
  processamentoSpedId: string,
  registroCodigo: string,
  isEdit: boolean,
  queryClient: QueryClient,
) => {
  return useMutation({
    mutationFn: (payload: any) =>
      saveRegistro(processamentoSpedId, registroCodigo, payload, isEdit),
    onSuccess: () => invalidateQueries(queryClient, registroCodigo),
  });
};
